<template>
    <div>
				<div class="footer"><br>
						<h4>
						<div class="row align-items-center">
							<div class="col-sm-12 col-md-4">
								<a href="#" class="footer__link">&thinsp;&thinsp;&thinsp;&thinsp;©2015-{{new Date().getFullYear() }}&thinsp;&thinsp;
									«Наполеон»&thinsp;&thinsp;</a>
							</div>
								<div class="col-sm-12 col-md-4">
								<a href="/consent.html" rel="modal:open" class="footer__link">Пользовательское
									соглашение&thinsp;&thinsp;</a>
							</div>
							<div class="col-4 col-md-4 align-self-end desktop">
									Version <span v-if="options[0]">{{options[0].ver}}</span>
							</div>
						</div>
						</h4>
					</div>
        </div>
</template>

<script>
export default {
    data () {
        return {
            options: [{ver:0.1}],
            urls: {
            option: "/api/option/list",
          }
        }
    },
    methods: {
      loadData(){
        axios.get("api/option").then(({ data }) => (this.options = data.data.data));
        axios.get(this.urls.option)
            .then(({ data }) => (this.options = data.data))
            .catch((errors) => {
              this.toastError(errors.response.data.errors);
            });
      }
    },
  created() {
    //this.loadData();
  }
}
</script>

<style scoped>

</style>
